export const TRANSLATIONS_IT = {
  username: "Username",
  password: "Password",
  login: "LOGIN",
  registerMsg: "Non sei ancora registrato?",
  registerMsg2: "Clicca qui",
  modalMsg: "Password e/o username errati",
};
